import React, { useEffect, useState } from "react";
import { auth, db } from "./firebase";
import { deleteDoc, doc, collection, getDocs, query, orderBy } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { isIOSApp } from "./utils/platform";

function ResumeLibrary() {

  const [resumes, setResumes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedResume, setSelectedResume] = useState(null);

  const navigate = useNavigate();
  const user = auth.currentUser;


  useEffect(() => {
    if (!user) return;

    const fetchResumes = async () => {
      try {
        const q = query(
          collection(db, "users", user.uid, "resumes"),
          orderBy("createdAt", "desc")
        );

        const snapshot = await getDocs(q);

        const data = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));

        setResumes(data);
      } catch (err) {
        console.error("Error loading resumes:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchResumes();
  }, [user]);
  
  const openPDF = (url) => {
  if (!url) return;

  if (isIOSApp() || window.innerWidth < 768) {
    navigate("/pdf-viewer", { state: { pdfUrl: url } });
  } else {
    window.open(url, "_blank", "noopener,noreferrer");
  }
};

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#4A4A8A",
        padding: "60px 16px",
      }}
    >
      <div
        style={{
          maxWidth: "600px",
          margin: "0 auto",
          padding: "28px",
          backgroundColor: "#ffffff",
          color: "#1f2937",
          borderRadius: "14px",
          boxShadow: "0 12px 30px rgba(0,0,0,0.15)",
        }}
      >
        <h2 style={{ marginBottom: "20px" }}>My Resumes</h2>

        {loading ? (
          <p>Loading resumes…</p>
        ) : resumes.length === 0 ? (
          <p>No resumes yet. Generate one to get started.</p>
        ) : (
          resumes.map((resume) => (
            <div
              key={resume.id}
              onClick={() => setSelectedResume(resume)}
              style={{
                padding: "14px",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                marginBottom: "12px",
                cursor: "pointer",
              }}
            >
              <strong>{resume.title || "Untitled Resume"}</strong>
              <div style={{ fontSize: "14px", color: "#6b7280" }}>
                Template: {resume.template}
              </div>
            </div>
          ))
        )}
        {selectedResume && (
  <div
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.6)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 999,
    }}
  >
    <div
      style={{
        background: "#fff",
        padding: "24px",
        borderRadius: "12px",
        width: "90%",
        maxWidth: "400px",
      }}
    >
      <h3 style={{ marginBottom: "16px" }}>
        {selectedResume.template?.toUpperCase()} Resume
      </h3>

      <button
        style={{ marginBottom: "10px", width: "100%" }}
        onClick={() => openPDF(selectedResume.pdfUrl)}
      >
        View / Download
      </button>

      <button
        style={{ marginBottom: "10px", width: "100%" }}
        onClick={async () => {
          await deleteDoc(
            doc(db, "users", user.uid, "resumes", selectedResume.id)
          );

          setResumes(resumes.filter(r => r.id !== selectedResume.id));
          setSelectedResume(null);
        }}
      >
        Delete Resume
      </button>

      <button
        style={{
          marginTop: "12px",
          width: "100%",
          background: "#e5e7eb",
        }}
        onClick={() => setSelectedResume(null)}
      >
        Close
      </button>
    </div>
  </div>
)}

      </div>
    </div>
  );
}

export default ResumeLibrary;
